import * as MyEarcut from "earcut";
import { PolygonMeshBuilder } from "@babylonjs/core/Meshes/polygonMesh";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { ElementGeometry } from "./ElementGeometry";
import { Util } from "../../utils/Util";
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
export class Building extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mWidth = 0;
        this.mDepth = 0;
        this.mminPoint = Vector3.Zero();
        this.mmaxPoint = Vector3.Zero();
        this.mElementParams = {};
    }
    getType() {
        return ("Building");
    }
    setMesh(pMesh) {
        //
    }
    minPoint() {
        return this.mminPoint;
    }
    maxPoint() {
        return this.mmaxPoint;
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 10;
        tParams.depth = 10;
        tParams.height = 4;
        tParams.floorOffset = 0.0;
        tParams.color = "#EEEEEE";
        return (tParams);
    }
    setPoints(pPoints) {
        if (pPoints == null)
            return;
        this.mPoints = [];
        this.mPoints = pPoints;
        this.mPoints = this.correctDirection(pPoints);
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.calcSize();
    }
    create2dGeometry(pParent) {
        if (this.mRoomElement.Params.ElementPoints == null)
            return;
        if (this.mRoomElement.Params.ElementPoints.length < 2)
            return;
        let tmesh2d = this.createBuilding(pParent);
        this.mRoomManager.app.model.layers.setMeshLayer(tmesh2d, "room:Building_Layer");
    }
    create3dGeometry(pParent) {
        if (this.mRoomElement.Params.ElementPoints == null)
            return;
        if (this.mRoomElement.Params.ElementPoints.length < 2)
            return;
        let tmesh3d = this.createBuilding(pParent);
        this.mRoomManager.app.model.layers.setMeshLayer(tmesh3d, "room:Building_Layer");
    }
    getProperties() {
        let tProperties = new Array();
        /*
        let tColorChoices = new Array<PropertyValue>();
        for (let tCol of this.mRoomManager._wallColors)
            tColorChoices.push(this.mRoomManager._getWallColorPropValue(tCol));

        //color
        let tColorRProp = new StringProperty(this.mRoomElement, Building.PROP_KEY_COLOR,
            I18N("Color", this.mRoomManager));
        tColorRProp.choiceList = true;
        tColorRProp.getChoices = () => Promise.resolve(tColorChoices);
        tColorRProp.getValue = () => this.mRoomManager._getWallColorPropValue(this.mRoomElement.color);
        tColorRProp.setValue = (pValue) =>
        {
            if (pValue != null) {
                let tColor = StringProperty.convertValueToString(pValue)!;
                this.mRoomElement.setColor(tColor);
                return (Promise.resolve(PropertyChangedResult.Value));
            } else
                return (Promise.resolve(PropertyChangedResult.Nothing));
        }
        tProperties.push(tColorRProp);
        */
        return (tProperties);
    }
    serializeIOData() {
        return (this.mElementParams);
    }
    loadIOData(pData) {
        let tParams = pData;
        let tPoints = new Array();
        for (let tEP of tParams.ElementPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tEP.x;
            tP.z = tEP.z;
            tPoints.push(tP);
        }
        this.setPoints(tPoints);
    }
    correctDirection(pPoints) {
        let tRes = new Array();
        tRes = pPoints;
        if (Util._clockWise3(tRes)) {
            tRes.reverse();
        }
        return (tRes);
    }
    calcSize() {
        if (this.mPoints == null)
            return;
        if (this.mPoints.length == 0)
            return;
        let tminX = this.mPoints[0].x;
        let tminY = this.mPoints[0].z;
        let tmaxX = this.mPoints[0].x;
        let tmaxY = this.mPoints[0].z;
        for (let tPoint of this.mPoints) {
            tminX = Math.min(tPoint.x, tminX);
            tmaxX = Math.max(tPoint.x, tmaxX);
            tminY = Math.min(tPoint.z, tminY);
            tmaxY = Math.max(tPoint.z, tmaxY);
        }
        this.mWidth = tmaxX - tminX;
        this.mDepth = tmaxY - tminY;
        this.mRoomElement.setWidth(this.mWidth, false);
        this.mRoomElement.setDepth(this.mDepth, false);
        this.mminPoint = new Vector3(tminX, 0, tminY);
        this.mmaxPoint = new Vector3(tmaxX, this.mRoomElement.height, tmaxY);
    }
    createBuilding(pParent) {
        let tpoly = new PolygonMeshBuilder("", Util.to2dArray(this.mRoomElement.Params.ElementPoints), this.mScene, MyEarcut);
        let tBuilding = tpoly.build(false, this.mRoomElement.height);
        tBuilding.isPickable = true;
        tBuilding.parent = pParent;
        tBuilding.material = this.mRoomManager.MatManager.getMaterial(this.mRoomElement.materialId);
        if (tBuilding.material !== null)
            tBuilding.material.backFaceCulling = true;
        tBuilding.position.y = this.mRoomElement.height;
        ShadowGenerator.disableMeshShadow(tBuilding);
        this.mRoomManager.app.model.layers.setMeshLayer(tBuilding, "room:Building_Layer");
        this.prepare3dMesh(tBuilding);
        return (tBuilding);
    }
}
